const messages = {
  title: 'Intern feil',
  description: 'Data for denne siden kan ikke lastes inn riktig.',
  backHomeButton: 'Tilbake til dashbord'
}

export default {
  messages
}
